import { createContext } from 'react';

export const defaultSettings = {
  colorPreset: 'yellow',
  contrast: 'normal',
  direction: 'ltr',
  layout: 'vertical',
  navColor: 'discrete',
  paletteMode: 'light',
  responsiveFontSizes: true,
  stretch: true,
};

export const initialState = {
  ...defaultSettings,
  isInitialized: true,
  openDrawer: false,
};

export const SettingsContext = createContext({
  ...initialState,
  handleDrawerClose: () => {},
  handleDrawerOpen: () => {},
  handleReset: () => {},
  handleUpdate: () => {},
  isCustom: false,
});
